<template>
    <div class="pm-gallery-group-item renderfix" @click="$bus.$emit('openGallery', settings.id)" v-show="imageNum > 0">
        <figure :key="grid + thumbsrc" :style="'background-image: url(' + thumbSrc + ')'">
            <mdi v-if="!settings.thumb" class="grey--text text--lighten-4" :size="48">tooth-outline</mdi>
        </figure>
        <div class="pm-gallery-group-item-header renderfix">
            <span class="bold--text">{{ title }}</span>
            <template v-if="imageNum > 0"><br/><small>{{ imageNum }} {{ $t('photos.images') }}</small></template>
        </div>
    </div>
</template>
<style>
.pm-gallery-group-item {
    position: relative;
}
.pm-gallery-group-item figure {
    background-color: #eee;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    box-shadow: 0 0 1px #777, 2px -2px 1px #fff, 3px -3px 1px #d6d6d6, 5px -5px 1px #fff, 6px -6px 1px #ddd;
    position: relative;
}
.pm-gallery-group-item-header {
    line-height: 1.2;
    font-size: 12px;
    padding: 8px 0px 8px 0px;
}
.pm-gallery-group-item-fav {
    position: absolute;
    top: -2px;
    right: 4px;
}

.pm-gallery-grid-4 .pm-gallery-group-item figure {
    height: Calc(100vw / 4 - 30px);
}
.pm-gallery-grid-3 .pm-gallery-group-item figure {
    height: Calc(100vw / 3 - 32px);
}
.pm-gallery-grid-2 .pm-gallery-group-item figure {
    height: Calc((100vw / 2) - 32px);
}
.pm-gallery-grid-1 .pm-gallery-group-item figure {
    height: Calc(100vw - 32px);
}

@media (min-width: 700px) {
    .pm-gallery-group-item-header {
        font-size: 14px;
    }

    .pm-gallery-group-item-header small {
        font-size: 12px;
    }
}
</style>
<script>
import mixinMethodFavved from "./mixin-method-favved";
import mixinComputedTitle from "./mixin-computed-title";
import MediaList from "../../configs/gallery/media";

const defaultGrid = 2;

export default {
    mixins: [
        mixinMethodFavved,
        mixinComputedTitle
    ],
    props: {
        settings: {
            type: Object,
        },
    },
    data() {
        return {
            grid: defaultGrid,
        }
    },
    computed: {
        favved() {
            return this.isFavved('favvedGalleryItems', this.settings.id);
        },
        imageNum() {
            if (typeof this.settings.imgNum === "undefined") {
                return -1;
            }
            return this.settings.imgNum;
        },
        thumbSrc() {
            const rootUrl = "https://cdn.denticalc.com/photos/";
            this.grid = localStorage.getItem('galleryGrid') ? parseInt(localStorage.getItem('galleryGrid')) : defaultGrid;

            const suffix = (document.body.getBoundingClientRect().width > 600 || this.grid <= 2) ? '_thumb_guetzli.jpg' : '_thumb_xs_guetzli.jpg';
            return rootUrl + this.settings.thumb.replace('.jpg',suffix);
        },
    },
    created() {
        this.$bus.$on('galleryGridToggled', () => {
            this.grid = localStorage.getItem('galleryGrid') ? localStorage.getItem('galleryGrid') : defaultGrid;
            this.$forceUpdate();
        });
    }
};
</script>
